import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const initialize = createAction(`${actionTypePrefix}/INITIALIZE`, (deviationId)=>({
        deviationId
    }));
export const requestSuccess = createAction(`${actionTypePrefix}/REQUEST_SUCCESS`, (deviationId, data)=>({
        deviationId,
        data
    }));
export const requestFailure = createAction(`${actionTypePrefix}/REQUEST_FAILURE`, (deviationId)=>({
        deviationId
    }));
export const submit = createAction(`${actionTypePrefix}/SUBMIT`, (typeid, deviationId, answers)=>({
        typeid,
        deviationId,
        answers
    }));
export const submitSuccess = createAction(`${actionTypePrefix}/SUBMIT_SUCCESS`, (deviationId)=>({
        deviationId
    }));
export const submitFailure = createAction(`${actionTypePrefix}/SUBMIT_FAILURE`, ()=>({}));
